export const getPathParamName = (path: string) => {
  return path.match(/:([^/]*)/gm)?.map(paramName => paramName.substring(1))[0] ?? '';
};
